/**
 * RAOC-22 PR-2 — Internal helper for `useRovoConfig`.
 * Not exported via a package subpath.
 */

import { type FireAnalyticsEvent } from '../../common/utils/analytics/types';

export type CacheRequestName = 'combined-config' | 'outbound-auth-github';

type onCacheAccessArgs = {
	requestName: CacheRequestName;
	searchSessionId: string;
	cacheHit: boolean;
	refreshTriggered: boolean;
	source: string;
};

// Record the hit/miss rate of request caching.
export const onRequestCacheAccess = ({
	requestName,
	searchSessionId,
	cacheHit,
	refreshTriggered,
	source,
}: onCacheAccessArgs): FireAnalyticsEvent => {
	return {
		source,
		action: 'requestCacheAccess',
		actionSubject: 'rovoConnectorsConfig',
		eventType: 'track',
		attributes: {
			additionalAttributes: {
				requestName,
				cacheHit,
				refreshTriggered,
				searchSessionId,
			},
		},
	};
};
